
import Vue from "vue";
import Api from "@/services/Api";
import { AxiosResponse } from "axios";
import { Overlay } from "@/lib/Overlay";
import moment from "moment";
import { Snackbar } from "@/lib/Snackbar";
import Swal from "sweetalert2";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
export interface FormCreateIntegracao {
  name?: string;
  description?: string;
  domain?: number;
  transactionPin?: string;
}
export interface FormAddIp {
  ip?: string;
  projetct_id?: string;
  transactionPin?: string;
}
export interface FormRemoveIp {
  ip?: string;
  projetct_id?: string;
  transactionPin?: string;
}
export interface FormRemoveWebHook {
  webhook_id?: string;
  projetct_id?: string;
  transactionPin?: string;
}
export interface FormNovoWebhook {
  endpoint?: string;
  projetct_id?: string;
  transactionPin?: string;
  events?: string;
  usuario?: string;
  senha?: string;
}

export default Vue.extend({
  name: "Integrações",

  data() {
    return {
      dialogShowSignature: false,
      dialogShowAuth: false,
      signatureSecret: "",
      webhookAuth: "",
      dialogNovoWebhook: false,
      dialogAddIp: false,
      dialogRemoveIp: false,
      dialogRemoveWebhook: false,
      dialogCredenciais: false,
      dialogTermosApi: false,
      dialogSolicitacaoUso: false,
      pinCode: "",
      tipoConta: "PF",
      formIntegracao: {} as FormCreateIntegracao,
      formAdicionaIp: {} as FormAddIp,
      formDeletaIp: {} as FormRemoveIp,
      formAdicionaWebook: {} as FormNovoWebhook,
      formDeletaWebHook: {} as FormRemoveWebHook,
      dialogRemoveProject: false,
      dialogShowTokens: false,

      dialogRequestProject: false,

      loadingData: true,
      businessInfo: "",
      btnloading: false,

      requestTokenDomain: "",
      pinCodeRequestToken: "",
      lang: navigator.language,
      ckConfirmCopyTokens: false,
      errors: [] as any,
      ckTermosApi: false,
      moment: moment,
      isMobile: false,
      ModuloInfo: [] as any,
      cadastroInfo: [],
      hasIntegracao: false,

      integracaoData: {} as any,
      hasBloqueioTokens: false,
      projetctAccess: {
        project_id: "a",
        client_secret: "b",
      },
      htmlTermosApi:
        "<h3>TERMO DE ADESÃO DISPOSITIVO DE SEGURANÇA - TOKEN</h3>          <h4>I - Partes</h4>          <p>            INTERMEDIADOR: <strong>EZZEBANK SOLUCOES DE PAGAMENTOS EIRELI</strong>, pessoa jurídica de direito privado, com inscrição no CNPJ sob o nº 37.743.906/0001-06, com sede à AE AREA ESPECIAL 4 LOTE I/J TORRE 03, BAIRRO GUARA II, Brasília, DF, CEP 71070-640.          </p>          <p>CLIENTE- pessoa jurídica e/ou equiparada qualificada na Ficha Proposta de Abertura de Conta, por seus legítimos representantes e usuários autorizados.</p>          <p>            Pelo presente instrumento, o INTERMEDIADOR acima identificado, propõe, e o CLIENTE aceita sem qualquer restrição, os seguintes termos e condições:          </p>          <p>            1. O INTERMEDIADOR, visando aumentar a segurança e identificação do CLIENTE no acesso para consulta e transações no âmbito de seu sistema, disponibiliza ao CLIENTE dispositivo denominado 'TOKEN VIRTUAL', que propicia a geração de um código de autenticação de transações realizadas em ambientes seguro VIA API.          </p>          <p>2. O CLIENTE adere sem qualquer ressalva ou restrição aos termos e condições aqui estabelecidos, os quais, doravante, integram e complementam as Condições Gerais do Contrato de Conta Digital e Outras Avenças ('Contrato').          </p>          <h4>DO TOKEN VIRTUAL</h4><p>            3. O CLIENTE declara que ao aceitar e utilizar o TOKEN, as transações realizadas em ambiente eletrônico do INTERMEDIADOR deverão necessariamente ter a digitação do código gerado pelo Token, especificamente para a referida transação, em razão do que a transação será considerada inequivocamente realizada pelo CLIENTE, não sendo passível de repúdio. <strong>Para tanto, o CLIENTE está ciente e autoriza que o TOKEN VIRTUAL colete dados do dispositivo necessários para estabelecer o vínculo de autenticação, inclusive do login e transação realizada no ambiente eletrônico, bem como aceita e concorda que os logs de autenticação, acesso e navegação provarão para todos os fins a legitimidade e autenticidade das transações realizadas.</strong>          </p>          <p>4. O CLIENTE declara que o TOKEN VIRTUAL somente deverá ser utilizado para os fins a que se destina, sendo vedado qualquer outro uso fora deste escopo.          </p>          <p>5. O CLIENTE responderá integralmente pelas operações efetuadas mediante uso do TOKEN VIRTUAL, acatando todos os lançamentos correspondentes e assumirá eventuais danos que vier a sofrer em razão do uso indevido do TOKEN VIRTUAL ou por negligência na sua guarda.          </p>          <p>6. O CLIENTE autoriza o INTERMEDIADOR, em caráter irrevogável e irretratável, a debitar todo e qualquer valor relativo as tarifas e responsabilidades previstas no presente Termo, em qualquer conta corrente de sua titularidade, mantida no INTERMEDIADOR.          </p>          <p>Ficam ratificadas todas as demais cláusulas, condições e garantias pactuadas no Contrato, complementadas, no que couber, pelo disposto no presente Termo.          </p>         ",
      hasInfoSituacaoConta: false,
      loadedData: false,
      situacaoConta: { mfaEnabled: true },
      eventosWebhooks: ["PIX_CASHIN", "PIX_CASHOUT", 'BOLETO_CASHIN','INFRACTION'],
    };
  },
  created() {
    this.isMobile = this.detectMobile();
    this.getSituacaoConta();
  },

  methods: {
    detectMobile() {
      if (screen.width <= 760) {
        return true;
      } else {
        return false;
      }
    },

    CriarIntegracao() {
      if (!this.ckTermosApi) {
        Snackbar.show(
          String(this.$t('components.integrations.template.dialogNovoWebhook.form.snackBarErrorCheck')),
          "error"
        );
        return false;
      }

      Overlay.show();
      this.btnloading = true;

      Api.post("/v2/client/api_projects/create", this.formIntegracao)
        .then((response) => {
          this.dialogRequestProject = false;
          this.projetctAccess = response.data.body;
          this.ckConfirmCopyTokens = false;
          this.dialogShowTokens = true;
          this.pinCodeRequestToken = "";
          this.formIntegracao.transactionPin = "";
          this.moduloInfo();
          this.dialogCredenciais = true;
        })
        .catch((error: any) => {
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;
          if (status === 422) {
            this.errors = data.body.errors;
          } else {
            Swal.fire({
              text: data.body.error,
              icon: "error",
              confirmButtonText: "Ok",
              showConfirmButton: true,
              customClass: {
                confirmButton: "d-block",
              },
            });
          }
        })
        .finally(() => {
          this.btnloading = false;
          this.formIntegracao.transactionPin = "";
          Overlay.hide();
        });
    },
    AdicionaIP() {
      Overlay.show();
      this.btnloading = true;
      this.dialogAddIp = false;
      Api.post("/v2/client/api_projects/ips/add", this.formAdicionaIp)
        .then((response) => {
          this.formAdicionaIp.transactionPin = "";
          this.formAdicionaIp.ip = "";
          Snackbar.show("IP Adicionado", "success");
          this.dialogAddIp = false;
          this.moduloInfo();
        })
        .catch((error: any) => {
          this.dialogAddIp = true;
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;
          if (status === 422) {
            this.errors = data.body.errors;
          } else {
            Swal.fire({
              text: data.body.error,
              icon: "error",
              confirmButtonText: "Ok",
              showConfirmButton: true,
              customClass: {
                confirmButton: "d-block",
              },
            });
          }
        })
        .finally(() => {
          this.btnloading = false;

          Overlay.hide();
        });
    },

    AdicionaWebhook() {
      Overlay.show();
      this.btnloading = true;
      this.dialogNovoWebhook = false;
      Api.post("/v2/client/api_projects/webhooks/add", this.formAdicionaWebook)
        .then((response) => {
          this.formAdicionaWebook.transactionPin = "";
          this.formAdicionaWebook.endpoint = "";
          Snackbar.show("Webbook Adicionado", "success");
          this.dialogNovoWebhook = false;
          this.moduloInfo();
        })
        .catch((error: any) => {
          this.dialogNovoWebhook = true;
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;
          if (status === 422) {
            this.errors = data.body.errors;
          } else {
            Swal.fire({
              text: data.body.error,
              icon: "error",
              confirmButtonText: "Ok",
              showConfirmButton: true,
              customClass: {
                confirmButton: "d-block",
              },
            });
          }
        })
        .finally(() => {
          this.btnloading = false;

          Overlay.hide();
        });
    },
    dialogConfirmRemoveIp(ip: string) {
      this.formDeletaIp.ip = ip;
      this.dialogRemoveIp = true;
    },

    dialogConfirmRemoveWebhook(id: string) {
      this.formDeletaWebHook.webhook_id = id;
      this.dialogRemoveWebhook = true;
    },

    ConfirmRemoveIP() {
      Overlay.show();
      this.btnloading = true;
      this.formDeletaIp.projetct_id = this.formAdicionaIp.projetct_id;

      Api.post("/v2/client/api_projects/ips/remove", this.formDeletaIp)
        .then((response) => {
          this.formDeletaIp.transactionPin = "";
          this.formAdicionaIp.ip = "";
          Snackbar.show("IP Removido", "success");
          this.dialogRemoveIp = false;
          this.moduloInfo();
        })
        .catch((error: any) => {
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;
          if (status === 422) {
            this.errors = data.body.errors;
          } else {
            Swal.fire({
              text: data.body.error,
              icon: "error",
              confirmButtonText: "Ok",
              showConfirmButton: true,
              customClass: {
                confirmButton: "d-block",
              },
            });
          }
        })
        .finally(() => {
          this.btnloading = false;

          Overlay.hide();
        });
    },
    ConfirmRemoveWebhook() {
      Overlay.show();
      this.btnloading = true;
      this.formDeletaWebHook.projetct_id = this.formAdicionaWebook.projetct_id;

      Api.post(
        "/v2/client/api_projects/webhooks/remove",
        this.formDeletaWebHook
      )
        .then((response) => {
          this.formDeletaWebHook.transactionPin = "";
          this.formDeletaWebHook.webhook_id = "";
          Snackbar.show("Webhook Removido", "success");
          this.dialogRemoveWebhook = false;
          this.moduloInfo();
        })
        .catch((error: any) => {
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;
          if (status === 422) {
            this.errors = data.body.errors;
          } else {
            Swal.fire({
              text: data.body.error,
              icon: "error",
              confirmButtonText: "Ok",
              showConfirmButton: true,
              customClass: {
                confirmButton: "d-block",
              },
            });
          }
        })
        .finally(() => {
          this.btnloading = false;

          Overlay.hide();
        });
    },

    moduloInfo() {
      this.loadingData = true;
      Overlay.show();
      Api.get("/v2/client/api_projects/get")
        .then((response) => {
          this.hasIntegracao = response.data.body.hasIntegracao;
          // console.log(this.hasIntegracao);
          this.integracaoData = response.data.body.integracoes[0];
          this.ModuloInfo = response.data.body.modInfo;

          if (this.hasIntegracao) {
            this.formAdicionaIp.projetct_id =
              response.data.body.integracoes[0].project_id;
            this.formAdicionaWebook.projetct_id =
              response.data.body.integracoes[0].project_id;
            if (response.data.body.integracoes[0].status != 1) {
              this.hasBloqueioTokens = true;
            }
          }

          // this.ContasDisponivels = response.data.body.bancos;
        })
        .catch((error: any) => {
          //  console.log(error);
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;

          if (status == 404) {
            this.hasIntegracao = false;
          } else {
            Swal.fire({
              text: data.body.error,
              icon: "error",
              confirmButtonText: "Ok",
              showConfirmButton: true,
              customClass: {
                confirmButton: "d-block",
              },
            });
          }
        })
        .finally(() => {
          this.loadingData = false;
          Overlay.hide();
        });
    },
    cancelaIntegracao() {
      this.ckTermosApi = false;
      this.dialogRequestProject = false;
    },
    getSituacaoConta() {
      Overlay.show();
      this.loadingData = true;
      Api.get("/v2/client/dashboard/statusConta")
        .then((response) => {
          this.situacaoConta = response.data.body;
          this.hasInfoSituacaoConta = true;
          this.loadingData = false;
        })
        .catch((error: any) => {
          const response = error.response as AxiosResponse;
          const status = response.status;
          const data = response.data;
        })
        .finally(() => {
          Overlay.hide();
          this.moduloInfo();
        });
    },

    downloadCredentials(format: string) {
      Overlay.show();
      const body = {
        fileType: format,
        data: btoa(JSON.stringify(this.projetctAccess))
      }
      Api.post(
        "/v2/client/api_projects/credentials/download", body,
        {

          responseType: "arraybuffer",
        }
      )
        .then((response) => {
          let fileType = "";
          let fileExtension = "";
          switch (format) {
            case "pdf":
              fileType = "application/pdf";
              fileExtension = ".pdf";
              break;
            case "txt":
              fileType = "text/plain";
              fileExtension = ".txt";
              break;

          }
          const blob = new Blob([response.data], {
            type: fileType,
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download =
            "client-credentials" + fileExtension;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((error: any) => {
          const status = Number(error.response.status);
          if (status > 399) {
            Snackbar.show(error.response.data.errors[0].message, "error");
          }


          //
        })
        .finally(() => {
          Overlay.hide();
        });

    },

    showSignature($sign: string) {
      this.signatureSecret = $sign;
      this.dialogShowSignature = true;
    },
    showAuth($auth: string) {
      this.webhookAuth = $auth;
      this.dialogShowAuth = true;
    },
  },
});
